import React from 'react';
import cx from 'classnames';
import '../../../ui/accordions/Accordion/index.js';
import { AccordionSelect } from '../../../ui/accordions/AccordionSelect/index.js';
import '../../../ui/badges/Badge/index.js';
import '../../../ui/badges/BadgeIcon/index.js';
import '../../../ui/badges/Checked/index.js';
import '../../../ui/badges/Panel/index.js';
import '../../../ui/badges/Status/index.js';
import '../../../ui/badges/Tag/index.js';
import '../../../ui/buttons/BabyButton/Base.js';
import '../../../ui/buttons/BabyButton/variants/Chat/index.js';
import '../../../ui/buttons/BabyButton/variants/Menu/index.js';
import '../../../ui/buttons/BabyButton/variants/User/index.js';
import '../../../ui/buttons/BabyButton/variants/Vip/index.js';
import '../../../ui/buttons/BabyButton/variants/Wallet/index.js';
import '../../../ui/buttons/Button/index.js';
import '../../../ui/buttons/CloseButton/index.js';
import '../../../ui/buttons/DirectionButton/index.js';
import { GradientButton } from '../../../ui/buttons/GradientButton/index.js';
import '../../../ui/buttons/GradientButtonV2/index.js';
import '../../../ui/buttons/TabButton/index.js';
import '../../../ui/buttons/TabButtonV2/index.js';
import '../../../ui/buttons/TimerButton/index.js';
import '../../../ui/buttons/TimerButtonV2/index.js';
import '../../../ui/buttons/TimerButtonV3/index.js';
import '../../../ui/loaders/Loader/index.js';
import '../../../ui/loaders/ScreenLoader/index.js';
import '../../../ui/modals/Modal/MobileWrapperV2/index.js';
import '../../../ui/modals/Modal/Modal.js';
import '../../../ui/modals/Modal/ModalContentWrapper/index.js';
import '../../../ui/popups/Popper/index.js';
import '../../../ui/popups/Popup/BasePopup/index.js';
import '../../../ui/popups/Popup/Thumb/index.js';
import '../../../ui/popups/Popup/ThumbV2/index.js';
import '../../../ui/popups/Popup/InfoTooltip/index.js';
import '../../../ui/sliders/EmblaCarousel/index.js';
import '../../../ui/tables/Table/index.js';
import '../../../ui/tables/Table/TableTd/index.js';
import '../../../ui/tabs/Tabs/index.js';
import '../../../ui/tabs/TabsV2/index.js';
import { CryptoValue } from '../../../ui/texts/CryptoValue/index.js';
import '../../../ui/texts/AmountValue/index.js';
import { TitleWithCurrency } from '../../../ui/texts/TitleWithCurrency/index.js';
import '../../../ui/texts/Text/index.js';
import '../../../ui/texts/TextNavigation/index.js';
import '../../../ui/texts/MinValue/index.js';
import '../../../ui/socials/SocialsList/index.js';
import { SelectV5 } from '../../../form/SelectV5/index.js';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import { GradientWrapper } from '../../../common/GradientWrapper/index.js';
import '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import '../../../common/WithCustomScrollbar/index.js';
import styles from './index.module.scss.js';

const InstantRakeback = ({
  title,
  image,
  list,
  total,
  selectedCurrency,
  onClick,
  onCurrencyChange,
  v2,
  texts = {
    emptyText: "There is no rakeback available to claim! ",
    claim: "Claim",
    totalReward: "Total reward"
  },
  className,
  style,
  isLoading,
  ...props
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.box, className), style, ...props }, parseFloat(total.amount) ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: cx(styles.title), "data-animate-fade": true }, title), !v2 && /* @__PURE__ */ React.createElement("div", { className: cx(styles["select-wrapper"]), "data-animate-fade": true }, /* @__PURE__ */ React.createElement(
  SelectV5,
  {
    selectedIds: selectedCurrency,
    onSelect: (ids) => onCurrencyChange(ids),
    options: list,
    width: "100%",
    style: {
      width: "100%"
    }
  }
)), v2 && /* @__PURE__ */ React.createElement("div", { className: cx(styles["select-wrapper-v2"]) }, /* @__PURE__ */ React.createElement(
  AccordionSelect,
  {
    selectedId: selectedCurrency[0],
    onSelect: (id) => onCurrencyChange([id]),
    options: list,
    "data-animate-fade": true
  }
), /* @__PURE__ */ React.createElement(
  GradientWrapper,
  {
    className: cx(styles["rakeback-value"]),
    "data-animate-fade": true
  },
  /* @__PURE__ */ React.createElement(
    TitleWithCurrency,
    {
      amount: total.amount,
      icon: total.currencyIcon,
      title: texts.totalReward
    }
  )
))) : /* @__PURE__ */ React.createElement("div", { className: cx(styles["empty-message"]), "data-animate-fade": true }, texts.emptyText), !v2 && /* @__PURE__ */ React.createElement("div", { className: cx(styles.image), "data-animate-fade": true }, typeof image === "string" ? /* @__PURE__ */ React.createElement("img", { src: image, alt: "" }) : image), v2 ? !parseFloat(total.amount) && /* @__PURE__ */ React.createElement(GradientWrapper, { "data-animate-fade": true }, /* @__PURE__ */ React.createElement(
  TitleWithCurrency,
  {
    amount: total.amount,
    icon: total.currencyIcon,
    title: texts.totalReward
  }
)) : /* @__PURE__ */ React.createElement("div", { className: cx(styles.total), "data-animate-fade": true }, texts.totalReward, /* @__PURE__ */ React.createElement(
  CryptoValue,
  {
    amount: total.amount,
    currencyImg: total.currencyIcon,
    currency: total.currency,
    v2: true
  }
)), /* @__PURE__ */ React.createElement(
  GradientButton,
  {
    kind: "fill",
    text: texts.claim,
    onClick,
    size: "md-2",
    disabled: !parseFloat(total.amount),
    "data-animate-fade": true,
    isLoading
  }
));
InstantRakeback.displayName = "InstantRakeback";

export { InstantRakeback };
//# sourceMappingURL=index.js.map
